export const ACTION_TYPES = {
  OPEN_OVER_SCREEN_MODAL: "overScreenModal/OPEN",
  CLOSE_OVER_SCREEN_MODAL: "overScreenModal/CLOSE"
};

export const openOverScreenModal = ({
  headerImage,
  title,
  description,
  mainButtonText,
  mainButtonHref,
  openHrefInBlank,
  secondaryButtonText,
  showCloseIcon
}) => ({
  type: ACTION_TYPES.OPEN_OVER_SCREEN_MODAL,
  payload: {
    headerImage,
    title,
    description,
    mainButtonText,
    mainButtonHref,
    openHrefInBlank,
    secondaryButtonText,
    showCloseIcon
  }
});

export const closeOverScreenModal = () => ({
  type: ACTION_TYPES.CLOSE_OVER_SCREEN_MODAL
});
